export function addClass(el: HTMLElement, className: string) {
  // 如果当前元素样式列表中没有className
  if (!el.classList.contains(className)) {
    el.classList.add(className)
  }
}

export function removeClass(el: HTMLElement, className: string) {
  el.classList.remove(className)
}
